// extracted by mini-css-extract-plugin
export var caption = "Video-module--caption--xsvu+";
export var root = "Video-module--root--tnuLq";